module.exports = __webpack_public_path__ + "static/carousel5-6be4787c8636332764b899bfec5cbaf1.jpg";